import { useQuery } from '@tanstack/react-query';
import { financialApi } from '../api/financialApi';

export const useReportDetails = (reportId: string) => {
  return useQuery({
    queryKey: ['report-details', reportId],
    queryFn: () => financialApi.getReportDetails(reportId),
    enabled: !!reportId,
  });
};
